/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
  return (
    <>
      <Navbar bg="default" variant="dark" style={{ marginLeft: "2%", marginTop:"15px" }}>
        <a style={{ fontSize: "1.5rem", fontWeight: 700, color: "#0c2e8a" }}>
          <img
            style={{ width: "40px" }}
            src="https://safetybot.in/img/favicon.png"
          ></img>{" "}
          Safety Check
        </a>
      </Navbar>
      {props.children}
    </>
  );
};
